import repeat from './repeat';

export default function(str, length, padchar, align) {
  var c = padchar || ' ',
      s = str + '',
      n = length - s.length;

  return n <= 0 ? s
    : align === 'left' ? repeat(c, n) + s
    : align === 'center' ? repeat(c, ~~(n/2)) + s + repeat(c, Math.ceil(n/2))
    : s + repeat(c, n);
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/pad.js
// module id = 1543
// module chunks = 0